var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaretDownWhite = function SvgCaretDownWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 1.444 5.188 4.93a.288.288 0 0 1-.377 0L1 1.444"
  })));
};
export { SvgCaretDownWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05IDEuNDQ0NDRMNS4xODg0NCA0LjkyODU4QzUuMTYzNzEgNC45NTEyMiA1LjEzNDM0IDQuOTY5MTggNS4xMDIgNC45ODE0NEM1LjA2OTY3IDQuOTkzNjkgNS4wMzUgNSA1IDVDNC45NjUgNSA0LjkzMDMzIDQuOTkzNjkgNC44OTggNC45ODE0NEM0Ljg2NTY2IDQuOTY5MTggNC44MzYyOSA0Ljk1MTIyIDQuODExNTYgNC45Mjg1OEwxIDEuNDQ0NDQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";